<template>
  <transition name="component-fade" mode="out-in">
    <Spinner class="mt-4" key="1" v-if="loading"></Spinner>
    <div v-else key="2">
      <div class="mb-3" v-if="topic">
        <div class="d-flex">
          <h5 class="fw-bold">{{ topic.title }}</h5>
          <div class="ms-auto d-flex">
            <CommunityNotifications :topic="topic.id"></CommunityNotifications>

            <div class="dropdown ms-3 d-lg-none">
              <button class="btn btn-outline-dark btn-sm" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="fas fa-sliders-h"></i>
              </button>
              <ul class="dropdown-menu">
                <li v-for="communityTopic in communityTopics" :key="communityTopic.id + communityTopic.title">
                  <a class="dropdown-item small fw-semibold" :href="communityTopic.url">{{ communityTopic.title }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="d-lg-none mt-3">
          <p v-if="topic.description" @click="toggleDescription">
            <span v-if="isDescriptionLong && !showFullDescription">{{ truncatedDescription }}…</span>
            <span v-else>{{ topic.description }}</span>
          </p>
        </div>
      </div>
      <div v-else class="mb-3 d-flex">
        <h5 class="fw-bold">{{ 'Community' | translate }}</h5>
        <div class="ms-auto d-flex">
            <div class="dropdown ms-1 d-lg-none">
              <button class="btn btn-outline-dark btn-sm" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="fas fa-sliders-h"></i>
              </button>
              <ul class="dropdown-menu">
                <li v-for="communityTopic in communityTopics" :key="communityTopic.id + communityTopic.title">
                  <a class="dropdown-item small fw-semibold" :href="communityTopic.url">{{ communityTopic.title }}</a>
                </li>
              </ul>
            </div>
          </div>
      </div>
      <PostCreate v-if="studentsCanPost" :topic="topic" @postCreated="postCreated"></PostCreate>
      <div v-if="noPosts" class="text-center">
        <img class="w-50 mt-5 mb-3" src="/images/undraw_empty_xct9.svg" alt="" />
        <h3 class="fw-light">
          {{ 'Oops... Nothing here yet' | translate }}
        </h3>
      </div>
      <div v-else>
        <Post v-for="post in posts" :key="post.id" :post="post"></Post>
      </div>
      <div class="d-grid">
        <button v-if="next_page_url" @click="loadMorePosts" class="btn btn-link" :disabled="loadingMore">
          <transition name="component-fade" mode="out-in">
            <span v-if="loadingMore">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span class="visually-hidden">Loading...</span>
            </span>
            <span v-else>{{ 'More' | translate }}</span>
          </transition>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import Spinner from '~/app2/components/Spinner'
import Post from '~/web-components/community/Post'
import PostCreate from '~/web-components/community/PostCreate'
import CommunityNotifications from '~/app2/components/community/CommunityNotifications.vue'
import _ from 'lodash'

export default {
  props: ['topicId', 'communityTopics'],
  components: {
    CommunityNotifications,
    Spinner,
    Post,
    PostCreate,
  },
  data() {
    return {
      loading: true,
      posts: [],
      topic: null,
      next_page_url: null,
      loadingMore: false,
      showFullDescription: false,
    }
  },
  mounted() {
    this.getPosts()
  },
  computed: {
    studentsCanPost() {
      return _.get(this.topic, 'allow_students_to_add_posts', false)
    },
    noPosts() {
      return _.isEmpty(this.posts)
    },
    isDescriptionLong() {
      return this.topic && this.topic.description && this.topic.description.length > 160
    },
    truncatedDescription() {
      if (!this.topic || !this.topic.description) return ''
      return this.topic.description.slice(0, 160).trim()
    },
  },
  methods: {
    toggleDescription() {
      this.showFullDescription = !this.showFullDescription
    },
    postCreated(data) {
      this.posts = [data, ...this.posts]
    },
    loadMorePosts() {
      if (!this.next_page_url) {
        return null
      }
      this.loadingMore = true
      return axios.post(this.next_page_url).then(({ data }) => {
        this.posts = [...this.posts, ...data.community_posts.data]
        this.next_page_url = this.setSameProtocol(data.community_posts.next_page_url)
        this.loadingMore = false
        return data
      })
    },
    setSameProtocol(url) {
      return _.replace(url, 'http:', location.protocol)
    },
    getPosts() {
      const url = this.topicId ? `/json/community/topics/${this.topicId}` : '/json/community'

      axios.post(url).then(({ data }) => {
        this.posts = [...this.posts, ...data.community_posts.data]
        this.topic = data.community_topic
        this.next_page_url = this.setSameProtocol(data.community_posts.next_page_url)
        this.loading = false
      })
    },
  },
}
</script>

<style></style>
